import React, { useEffect, useRef, useState } from "react";
import EventTile from "./EventTile";
import { artistNodeId, scrollToNextGroup } from "../utils/Utils";
import { useIsOverflowing } from "../hooks/useIsOverflowing";
import LeftArrow from "../assets/icons/left-arrow.svg";
import RightArrow from "../assets/icons/right-arrow.svg";
import useDevice from "../hooks/useDevice";
import EventsSectionsSkeleton from "./Skeletons/EventsSectionsSkeleton";
import { endpoints } from "../utils/Constants";
import SubmitBtn from "./submitButton";
import CalendarIcon from "../assets/icons/calendar.svg";
import StickyButton from "./BookStickyButton";

const EventsSection = ({ headerVisible }) => {
  const [eventGroups, setEventGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  let ref = useRef();

  const { isMobile } = useDevice();
  const isOverflowing = useIsOverflowing(ref);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    let culture = $('#lng').val();

    fetch(endpoints.event.getArtistEventGroups(artistNodeId(), culture), {
      method: "GET",
    })
      .then((res) => res.json())
      .then((result) => {
        setEventGroups(result);
        setLoading(false);
      })
      .catch((error) => {
        console.error(`Can't fetch media!`, error);
        setLoading(false);
      });
  };

  let tiles = eventGroups.map((eventGroup, index) => (
    <EventTile
      key={index}
      title={eventGroup.title}
      dates={eventGroup.dates}
      image={eventGroup.image}
      url={eventGroup.url}
      venue={eventGroup.venue}
      vertical={eventGroups.length > 3 || isMobile}
    />
  ));

  if (loading) return <EventsSectionsSkeleton />;

  return (
    <>
      <div
        id="r_eventsSection"
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0 16px",
          gap: 24,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span
            style={{
              color: "#0D0C1C",
              fontSize: 20,
              fontFamily: "pf_highway_sans_pro_mediumRg",
            }}
          >
            {artistpage_resources.Events}
          </span>
          {isOverflowing && (
            <div style={{ display: "flex", gap: 16 }}>
              <LeftArrow
                style={{ cursor: "pointer" }}
                onClick={() => scrollToNextGroup(ref, true)}
              />
              <RightArrow
                style={{ cursor: "pointer" }}
                onClick={() => scrollToNextGroup(ref)}
              />
            </div>
          )}
        </div>
        {eventGroups.length > 0 ? (
          <div
            ref={ref}
            style={{
              display: "flex",
              gap: 16,
              overflowX: "hidden",
              scrollSnapType: "x mandatory",
              paddingBottom: 24,
            }}
          >
            {tiles}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: 24,
              marginBottom: 16,
              gap: 16,
              borderRadius: 8,
              border: "1px solid var(--Colors-grey-grey-500, #EDF1F6)",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 8,
              }}
            >
              <CalendarIcon />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                }}
              >
                <span
                  style={{
                    fontSize: 16,
                    fontFamily: "pf_highway_sans_pro_mediumRg",
                    textAlign: "center",
                    lineHeight: "24px",
                  }}
                >
                  {artistpage_resources.NoUpcomingEvents}
                </span>
                <span
                  style={{
                    fontSize: 16,
                    textAlign: "center",
                    lineHeight: "24px",
                  }}
                >
                  {artistpage_resources.FollowArtist}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
      {eventGroups.length > 0 && (
        <StickyButton
          buttonText={artistpage_resources.Tickets}
          venueSeatsProp={null}
          headerVisible={headerVisible}
        />
      )}
    </>
  );
};

export default EventsSection;
